import { defineSlotRecipe } from '@chakra-ui/react';

export const selectSlotRecipe = defineSlotRecipe({
  className: 'chakra-select',
  slots: [
    'root',
    'hiddenSelect',
    'item',
    'itemIndicator',
    'positioner',
    'content',
    'indicator',
    'control',
    'label',
    'trigger',
    'itemGroup',
    'clearTrigger',
    'itemGroupLabel',
    'itemText',
    'valueText',
    'option',
    'indicatorGroup',
  ],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
    },
    label: {
      color: 'neutral.300',
    },
    control: {
      border: '2px solid',
      borderColor: 'neutral.black',
      padding: 0.25,
      height: 'inherit',
      width: 'inherit',
    },
    trigger: {
      fontFamily: 'roboto',
      borderRadius: 'none',
      border: 'none',
      overflow: 'ellipsis',
      cursor: 'pointer',
      _disabled: {
        cursor: 'default',
      },
    },
    indicatorGroup: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      padding: 0.25,
      borderLeft: '2px solid',
      borderColor: 'neutral.black',
      '&[data-active=true]': {
        backgroundColor: 'blue',
      },
      _groupHover: {
        backgroundColor: 'skyBlue',
      },
      '&[data-disabled=true]': {
        backgroundColor: 'transparent !important',
      },
    },
    indicator: {
      backgroundColor: 'neutral.black',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxSizing: 'border-box',
      color: 'neutral.white',
      '& svg': {
        boxSize: '24px !important',
      },
      _disabled: {
        color: 'neutral.700',
      },
      '&[data-active=true]': {
        backgroundColor: 'blue !important',
      },
      _groupHover: {
        backgroundColor: 'neutral.800',
      },
      '&[data-disabled=true]': {
        backgroundColor: 'neutral.black !important',
      },
    },
    valueText: {
      maxWidth: '100%',
      color: 'neutral.white',
      wordBreak: 'break-all',
      _disabled: {
        color: 'neutral.200',
      },
    },
    content: {
      borderRadius: 'none',
      border: '2px solid',
      paddingX: '0 !important',
      paddingY: '0 !important',
      borderColor: 'neutral.black',
      '&::-webkit-scrollbar': {
        width: '10px',
      },
      '&::-webkit-scrollbar-track': {
        background:
          'linear-gradient(to right, var(--chakra-colors-neutral-black) 20%, var(--chakra-colors-neutral-850) 20%, var(--chakra-colors-neutral-850) 100%)',
      },
      '&::-webkit-scrollbar-thumb': {
        cursor: 'pointer',
        background:
          'linear-gradient(to right, transparent 20%, var(--chakra-colors-neutral-600) 20%, var(--chakra-colors-neutral-600) 100%)',
        width: '10px',
      },
    },
    item: {
      borderRadius: 'none',
      backgroundColor: 'neutral.800',
      border: '2px solid',
      borderColor: 'neutral.800',
      cursor: 'pointer',
      _hover: {
        borderColor: 'skyBlue',
        backgroundColor: 'neutral.700',
      },
      '&[data-highlighted]': {
        borderColor: 'skyBlue',
        backgroundColor: 'neutral.700',
      },
      '&[data-state="checked"]': {
        backgroundColor: 'blue',
        borderColor: 'blue',
        _hover: {
          borderColor: 'skyBlue',
          backgroundColor: 'blue',
        },
      },
    },
    clearTrigger: {
      cursor: 'pointer',
      boxSize: '24px',
      color: 'neutral.300',
      _hover: {
        color: 'skyBlue',
      },
      '& svg': {
        boxSize: '24px !important',
      },
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    positioner: {
      width: 'calc(var(--reference-width) + 8px) !important',
      marginLeft: '-4px !important',
    },
  },
  variants: {
    variant: {
      default: {
        control: {
          backgroundColor: 'neutral.800',
        },
        trigger: {
          backgroundColor: 'neutral.800',
        },
        positioner: {
          backgroundColor: 'neutral.800',
        },
        content: {
          backgroundColor: 'neutral.800',
        },
      },
      darker: {
        control: {
          backgroundColor: 'neutral.900',
        },
        trigger: {
          backgroundColor: 'neutral.900',
        },
        positioner: {
          backgroundColor: 'neutral.900',
        },
        content: {
          backgroundColor: 'neutral.900',
        },
      },
    },
    size: {
      sm: {
        root: {
          height: '48px',
        },
        trigger: {
          height: '40px',
          padding: 1,
          paddingRight: '52px',
        },
        indicator: {
          boxSize: '40px',
        },
        item: {
          paddingX: '1',
          paddingY: '1',
        },
      },
      md: {
        root: {
          height: '56px',
        },
        trigger: {
          height: '48px',
          padding: 2,
          paddingRight: '76px',
        },
        indicator: {
          boxSize: '48px',
        },
        item: {
          paddingX: '1.5',
          paddingY: '1.5',
        },
      },
      lg: {
        root: {
          height: '92px',
        },
        trigger: {
          height: '84px',
          padding: 1,
          paddingRight: '52px',
        },
        indicator: {
          width: '40px',
          height: '84px',
        },
        item: {
          paddingX: '1',
          paddingY: '1',
        },
      },
    },
  },
  defaultVariants: {
    size: 'md',
    variant: 'default',
  },
});
